import React, { FC } from 'react';

import styled from 'styled-components';

import { ETypography } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

interface IDemoCompletionDetailItemProps {
  label: string;
  value: string | number | undefined;
  onClickLink?: () => void;
}

const DemoCompletionDetailItem: FC<IDemoCompletionDetailItemProps> = ({ label, value, onClickLink }) => {
  if (onClickLink) {
    return (
      <StyledDetailItemContainer onClick={onClickLink}>
        <StyledDetailKeyText typography={ETypography.TEXT_L_REGULAR}>{label}</StyledDetailKeyText>
        <StyledDetailLinkTextContainer>
          <StyledDetailLinkText typography={ETypography.TEXT_L_MEDIUM}>{value}</StyledDetailLinkText>
        </StyledDetailLinkTextContainer>
      </StyledDetailItemContainer>
    );
  }

  return (
    <StyledDetailItemContainer>
      <StyledDetailKeyText typography={ETypography.TEXT_L_REGULAR}>{label}</StyledDetailKeyText>
      <StyledDetailValueText typography={ETypography.TEXT_L_REGULAR}>{value}</StyledDetailValueText>
    </StyledDetailItemContainer>
  );
};

export default DemoCompletionDetailItem;

const StyledDetailItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledDetailKeyText = styled(UIText)`
  color: ${({ theme }) => theme.themeColors.text.subtle};
`;

const StyledDetailValueText = styled(UIText)`
  color: ${({ theme }) => theme.themeColors.text.strong};
`;

const StyledDetailLinkTextContainer = styled.div``;
const StyledDetailLinkText = styled(UIText)`
  cursor: pointer;
  color: ${({ theme }) => theme.themeColors.primary};
  text-decoration: underline;
`;
